/* eslint-disable no-underscore-dangle */
// vendors
import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Figure from '../Figure';
import Player from '../Player';

import { greaterThan } from '../../utils/mediaQuery';
import breakpoints from '../../styles/breakpoints';

const Container = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 40px;
  grid-template-columns: repeat(auto-fill, 1fr);

  justify-items: stretch;

  margin: 80px 0;

  ${greaterThan(breakpoints[0])} {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  ${greaterThan(breakpoints[4])} {
    grid-gap: 72px;
    grid-template-columns: repeat(auto-fill, minmax(333px, 1fr));
  }

  ${greaterThan(breakpoints[6])} {
    grid-template-columns: repeat(auto-fill, minmax(444px, 1fr));
  }
`;

const elementStyleReset = css`
  margin: 0;
`;

const Gallery = ({ nodes }) => {
  return (
    <Container>
      {nodes.map((node) => {
        if (node._type === 'figure') {
          return (
            <Figure
              node={node}
              css={elementStyleReset}
              fluidConfig={{
                maxWidth: 444,
                sizes:
                  '(max-width: 596px) 92vw, (max-width: 1200px) 44vw, 444px',
              }}
            />
          );
        }

        if (node._type === 'player') {
          return <Player node={node} css={elementStyleReset} />;
        }

        return <p>{node._type}</p>;
      })}
    </Container>
  );
};

Gallery.propTypes = {
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      _type: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Gallery;
